<div class="row">

    <div class="{{ classCol }}">
        <div class="form-group datepicker-group">
            <label for="field-date-debut" class="form-label" [ngClass]="{ 'form-label-required': isRequiredFromDate }">
                {{ fromDateLabel | translate }}
            </label>

            <div class="position-relative datepicker-input-container">
                <input #fromDateInput id="field-date-debut" matInput type="text" class="form-control" autocomplete="off"
                       inputRestriction="datePicker" [formControl]="fromDateControl" [min]="minDateDebut"
                       [max]="maxDateDebut" [matDatepicker]="pickerFromDate" appDateFormat (blur)="onFromDateBlur()"
                       (dateInput)="onValueChangeFrom($event.value)"
                       [class.is-invalid]="fromDateControl.dirty && fromDateControl.invalid" />

                <mat-datepicker-toggle matSuffix [for]="pickerFromDate"></mat-datepicker-toggle>

                <mat-datepicker #pickerFromDate [restoreFocus]="false"></mat-datepicker>
            </div>

            <form-control-feedback style="position: absolute" [field]="fromDateControl"></form-control-feedback>
        </div>
    </div>


    <div class="{{ classCol }}">
        <div class="form-group datepicker-group">
            <label for="field-date-fin" class="form-label" [ngClass]="{ 'form-label-required': isRequiredToDate }">
                {{ toDateLabel | translate }}
            </label>

            <div class="position-relative datepicker-input-container">
                <input #toDateInput id="field-date-fin" matInput type="text" class="form-control"
                       inputRestriction="datePicker" autocomplete="off" [formControl]="toDateControl" [min]="minDateFin"
                       [matDatepicker]="pickerToDate" appDateFormat (blur)="onToDateBlur()"
                       (dateInput)="onValueChangeTo($event.value)"
                       [class.is-invalid]="toDateControl.dirty && toDateControl.invalid" />

                <mat-datepicker-toggle matSuffix [for]="pickerToDate">
                </mat-datepicker-toggle>

                <mat-datepicker #pickerToDate [restoreFocus]="false">
                </mat-datepicker>
            </div>

            <form-control-feedback style="position: absolute" [field]="toDateControl">
            </form-control-feedback>
        </div>
    </div>
</div>
